import { DateService } from '@rocheglobal/component-library-dot-com/src/services/date';
import React, { MouseEvent, useEffect, useRef, useState } from 'react';
import { RocheImage as RocheImageType, RocheTeaser as RocheTeaserType } from '../../types/global';
import { parseAssetSource, parseDownloadSource } from '../../utils/asset';
import { StringService } from '../../services/string';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { AssetData } from '../../utils/asset/types';
import { RocheUITeaser } from '@repo/roche-ui';
import { handleRocheTeaserClick } from '../../helpers/roche-teaser-tracking';

type RocheDownloadTeaserProps = BlokToComponentProps<
  RocheTeaserType & {
    teaser_overline: string;
    teaser_title: string;
    teaser_image: RocheImageType[];
    internal_asset: AssetData;
    external_asset: string;
    publishing_date: string;
  }
>;

export const RocheDownloadTeaser = ({ blok, slot }: RocheDownloadTeaserProps): JSX.Element => {
  const [state, setState] = useState({
    formattedDate: '',
  });
  const teaserRef = useRef<HTMLDivElement>(null);

  const teaserImage = blok?.teaser_image?.[0];
  const internalAsset = blok?.internal_asset?.filename;
  const externalAsset = blok?.external_asset;
  const publishingDate = blok?.publishing_date;
  const externalAssetLink = `${process.env.GATSBY_CORS_HEADER_API}?url=${externalAsset}`;
  const teaserUrl = parseDownloadSource(internalAsset) || externalAssetLink;

  useEffect(() => {
    let isMounted = true;

    const getParsedDate = async (): Promise<void> => {
      const formattedDate =
        publishingDate && typeof document !== 'undefined'
          ? await DateService.formatDate(publishingDate, 'dateFull')
          : '';

      if (isMounted) {
        setState((prevState) => ({ ...prevState, formattedDate }));
      }
    };

    getParsedDate();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      {blok && (
        <RocheUITeaser
          ref={teaserRef}
          layout={blok.layout}
          teaserTitle={blok.teaser_title}
          teaserOverline={blok.teaser_overline || state.formattedDate}
          teaserDescription={StringService.getExtension(internalAsset || externalAsset).toUpperCase()}
          teaserImage={parseAssetSource(teaserImage?.src.filename)}
          teaserUrl={teaserUrl}
          isDownloadLink
          loaded={true}
          slot={slot}
          onTeaserClick={(e: MouseEvent) => handleRocheTeaserClick(e, blok.teaser_title, teaserUrl, teaserRef, true)}
        />
      )}
    </>
  );
};
